export class EmpleadoDto {
    constructor(
        public readonly Id: number,
        public readonly Legajo: string | null,
        public TipoDocumentoId: number | null,
        public TipoDocumentoNombre: string | null,
        public NroDocumento: string | null,
        public MovilContacto: string | null,
        public readonly MovilContactoOtro: string | null,
        public readonly DomicilioDni: string | null,
        public readonly CodigoPostalDni: string | null,
        public readonly DomicilioReal: string | null,
        public readonly CodigoPostalReal: string | null,
        public readonly Titulo: string | null,
        public readonly Posicion: string | null,
        public readonly RemuneracionNeta: number | null,
        public readonly RemuneracionExtra: number | null,
        public readonly ProvinciaId: number | null,
        public readonly LocalidadBarrio: string | null,
        public readonly EstadoCivilId: number | null,
        public Cuit: number | null,
        public FechaNacimiento: Date | null,
        public readonly ApellidoConviviente: string | null,
        public readonly NombreConviviente: string | null,
        public readonly DniConviviente: string | null,
        public readonly CantHijosACargo: number | null,
        public readonly SubcontratistaId: number | null,
        public PersonaId: number,
        public readonly GremioId: number | null,
        public Nombre: string | null,
        public Apellido: string | null,
        public readonly Matricula: string | null,
        public readonly Observaciones: string | null,
        public readonly GremioNombre: string | null,
        public MailContacto: string | null,
        public readonly ComunidadNombre: string | null,
        public readonly FechaIngreso: Date | null,
        public readonly FechaEgreso: Date | null,
        public readonly LocalidadBarrioReal: string | null,
        public readonly ProvinciaRealId: number | null,
        public readonly ComunidadRol: number | null,
        public Documentos: EmpleadoDocumento[],
        public Comunidades: EmpleadoComunidad[],
        public Aguinaldo: boolean | null,
        public Activo: boolean,
        public FotoDniFrenteUrl: string | null,
        public FotoDniDorsoUrl: string | null,
        public FotoSelfieUrl: string | null
    ) { }
}

export class EmpleadoComunidad {
    constructor(
        public readonly Id: number,
        public readonly ComunidadId: number,
        public readonly ComunidadNombre: string | null,
        public readonly EmpleadoId: number,
        public readonly Empleado: EmpleadoDto,
        public readonly FechaInicio: Date,
        public readonly FechaFin: Date
    ) { }
}

export class SaveEmpleadoComunidad {
    constructor(
        public readonly Id: number,
        public readonly ComunidadId: number | null,
        public readonly EmpleadoId: number | null,
        public readonly FechaInicio: Date | null,
        public readonly FechaFin: Date | null
    ) { }
}

export class SaveEmpleadoDto {
    constructor(
        public readonly Id: number,
        public readonly Legajo: string | null,
        public readonly NroBatch: string | null,
        public readonly NroDocumento: string | null,
        public readonly MovilContacto: string | null,
        public readonly TipoDocumentoId: number | null,
        public readonly ComunidadRol: number | null,
        public readonly PaisId: number | null,
        public readonly MailContacto: string | null,
        public readonly MovilContactoOtro: string | null,
        public readonly DomicilioDni: string | null,
        public readonly CodigoPostalDni: string | null,
        public readonly DomicilioReal: string | null,
        public readonly CodigoPostalReal: string | null,
        public readonly Titulo: string | null,
        public readonly Posicion: string | null,
        public readonly RemuneracionNeta: number | null,
        public readonly RemuneracionExtra: number | null,
        public readonly ProvinciaId: number | null,
        public readonly ProvinciaRealId: number | null,
        public readonly LocalidadBarrio: string | null,
        public readonly LocalidadBarrioReal: string | null,
        public readonly EstadoCivilId: number | null,
        public readonly Cuit: number | null,
        public readonly FechaNacimiento: Date | null,
        public readonly FechaIngreso: Date | null,
        public readonly FechaEgreso: Date | null,
        public readonly ApellidoConviviente: string | null,
        public readonly NombreConviviente: string | null,
        public readonly DniConviviente: string | null,
        public readonly CantHijosACargo: number | null,
        public readonly SubcontratistaId: number | null,
        public readonly PersonaId: number | null,
        public readonly GremioId: number | null,
        public readonly EmpleadoComunidad: SaveEmpleadoComunidad[],
        public readonly Activo: boolean | null,
        public Aguinaldo: boolean | null
    ) { }
}

export class UploadEmpleadoAttachResponseDto {
    constructor(
        public readonly Archivos: EmpleadoDocumento[]
    ) { }
}

export class EmpleadoDocumento {
    constructor(
        public readonly Id: number,
        public Descripcion: string | null,
        public readonly NombreDocumento: string | null,
        public readonly UrlDocumento: string | null,
        public readonly EmpleadoId: number,
    ) { }
}

export class SearchEmpleadoRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly PersonaId: number | null,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly NombreCompleto: string | null,
        public readonly MailContacto: string | null,
        public readonly MovilContacto: string | null,
        public readonly Matricula: string | null,
        public readonly GremioId: number | null,
        public readonly Cuit: string | null,
        public readonly SubcontratistaId: number | null,
        public readonly ComunidadRol: number | null,
        public readonly VerSubContratistas: boolean | null,
        public readonly VerSoloActivos: boolean | null
    ) { }
}

export class SearchEmpleadoResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchEmpleadoRequestDto[]
    ) { }
}

export class SearchEmpleadoItemDto {
    constructor(
        public readonly Id: number,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly NroDocumento: string | null,
        public readonly Estado: string | null,
        public readonly Movil: string | null,
        public readonly Mail: string | null,
        public readonly Matricula: string | null,
        public readonly Bloqueado: boolean,
        public readonly FotoPerfilUrl: string | null,
        public readonly Activo: boolean,
    ) { }
}


//! ----------------- Asistencia -----------------

export class EmpleadoAsistencia {
    constructor(
        public Id: number,
        public FechaAsistencia: Date,
        public Asistencia: number,
        public HorasAsistencia: number,
        public HorasJornada: number,
        public EmpleadoId: number,
        public ComunidadId: number,
        public GremioId: number,
        public Observacion: string | null,
        public MotivoInasistenciaId: number,
    ) { }
}
export class SaveEmpleadoAsistencia {
    constructor(
        public Id: number,
        public FechaAsistencia: Date,
        public Asistencia: number,
        public EmpleadoId: number,
        public ComunidadId: number,
        public GremioId: number,
        public HorasAsistencia: number,
        public HorasJornada: number,
        public Observacion: string | null,
        public MotivoInasistenciaId: number,
    ) { }
}

export class SearchEmpleadoAsistenciaExport {
    constructor(
        public EmpleadosId: number[]
    ) { }
}

export class SearchEmpleadoAsistenciaRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public FechaAsistencia: string | null,
        public FechaDesde: string | null,
        public FechaHasta: string | null,
        public Asistencia: number | null,
        public HorasAsistencia: number | null,
        public HorasJornada: number | null,
        public Cuit: string | null,
        public EmpleadoNombre: string | null,
        public EmpleadoApellido: string | null,
        public HorasTrabajadas: number | null,
        public ComunidadId: number | null,
        public Comunidades: string | null,
        public Empleados: string | null,
        public GremioId: number | null,
        public Legajo: string | null,
    ) { }
}

//! ----------------- Motivo Inasistencia -----------------

export class MotivoInasistencia {
    constructor(
        public Id: number,
        public Nombre: string | null,
        public Tipo: number | null,
        public Activo: boolean,
    ) { }
}
export class SaveMotivoInasistencia {
    constructor(
        public Id: number,
        public Nombre: string | null,
        public Tipo: number | null,
        public Activo: boolean,
    ) { }
}
export class SearchMotivoInasistenciaRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Nombre: string | null,
        public readonly Tipo: number | null,
        public readonly Activo: boolean | null,
    ) { }
}

export class EmpleadoComunidadHistorialDto {
    constructor(
        public Id: number,
        public EmpleadoId: number,
        public ComunidadId: number,
        public ComunidadNombre: string | null,
        public Descripcion: string | null,
        public FechaCreacion: Date,
    ) { }
}

export class ValidateAsistenciaComunidad {
    constructor(
        public Id: number,
        public EmpleadoId: number,
        public ComunidadId: number,
        public FechaInicio: Date,
        public FechaFin: Date,
    ) { }
}
